import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

export const HolidayComponent = ({ open, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [remark, setRemark] = useState("");

  const handleSubmit = () => {
    const payload = {
      startDate,
      endDate,
      remark,
    };
    console.log(payload);
    handleReset();
    onClose();
  };

  const handleReset = () => {
    setEndDate("");
    setStartDate("");
    setRemark("");
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullScreen>
        {/* Header */}
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "bold",
            padding: "16px 24px",
          }}
        >
          Holiday
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent sx={{ padding: "24px" }}>
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
            <Grid container spacing={3}>
              {/* Start Date */}
              <Grid item xs={12}>
                <TextField
                  label="Start Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) =>
                    setStartDate(dayjs(e.target.value).format("YYYY-MM-DD"))
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>

              {/* End Date */}
              <Grid item xs={12}>
                <TextField
                  label="End Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) =>
                    setEndDate(dayjs(e.target.value).format("YYYY-MM-DD"))
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="outlined-multiline-static"
                  label="Remarks"
                  multiline
                  rows={4}
                  fullWidth
                  value={remark}
                  style={{ resize: "both", overflow: "auto" }}
                  onChange={(e) => {
                    setRemark(e.target.value);
                  }}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                <Button
                  variant="contained"
                  sx={{
                    background:
                      "linear-gradient(135deg, #4CAF50 30%, #2E7D32 90%)",
                    color: "white",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "12px 32px",
                    fontSize: "16px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    transition: "0.3s",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #2E7D32 30%, #1B5E20 90%)",
                      boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                    },
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HolidayComponent;
